/** Turns a raw brand slug (e.g. `true_classic`) into a display name (`True Classic`). */
export function humanizeBrandName(raw: string): string {
  return raw
    .split(/[_-]+/)
    .filter(Boolean)
    .map((token) => token[0]!.toUpperCase() + token.slice(1))
    .join(" ");
}
